import { useCallback } from "react";
import moment from "moment-timezone";
import { Input } from "../../../../../ui/input";
import type { SingleAnchorProps } from "./types";

function Single({ setOpen, setDraft, placeholder, draft, formattedValue, disabled, dateFormat, onChange }: SingleAnchorProps) {
    const commitText = useCallback((text: string) => {
        setDraft(null);
        if (!text) {
            onChange?.(null);
            return;
        }
        const parsed = moment(text, dateFormat, true);
        if (parsed.isValid()) {
            onChange?.(parsed.toDate());
        }
    }, [dateFormat, onChange, setDraft]);

    return (
        <Input
            value={draft ?? formattedValue}
            placeholder={placeholder || dateFormat}
            disabled={disabled}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={(e) => commitText(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    commitText(e.currentTarget.value);
                } else if (e.key === "Escape") {
                    setOpen(false);
                }
            }}
            onFocus={() => setOpen(true)}
        />
    );
}

export default Single;
